import React, { Component } from "react";

import { Dropdown, Icon } from "semantic-ui-react";
import { jobassign } from "../../../actions/job-assign";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
class AddJob extends Component {
  render() {
    return (
      <div className="AddJob">
        <Dropdown icon="plus square outline" button className="icon" upward>
          <Dropdown.Menu>{this.genJob()}</Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { jobs: state.jobs };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      jobassign: jobassign
    },
    dispatch
  );
}
export default connect(mapStateToProps, matchDispatchToProps)(AddJob);



// WEBPACK FOOTER //
// ./src/components/shared-components/timesheet/addjob.js